import {Component, OnInit} from '@angular/core';
import {Router} from '@angular/router';
import {ApiService} from '../api.service';
import {HandlerService} from '../handler.service';
import {LocationService} from '../location.service';
import {Platform} from '@angular/cdk/platform';
import {Geolocation} from '@ionic-native/geolocation/ngx';
import {NativeGeocoderOptions, NativeGeocoder, NativeGeocoderResult} from '@ionic-native/native-geocoder/ngx';
import {LaunchNavigator, LaunchNavigatorOptions} from '@ionic-native/launch-navigator/ngx';
import {LocationAccuracy} from '@ionic-native/location-accuracy/ngx';

@Component({
    selector: 'app-set-location',
    templateUrl: './set-location.component.html',
    styleUrls: ['./set-location.component.scss'],
})
export class SetLocationComponent {

    constructor(private service: ApiService,
                public handler: HandlerService,
                private router: Router,
                public location: LocationService,
                private platform: Platform,
                private loc: Geolocation,
                private LocationAccuracy: LocationAccuracy,
                private launchNavigator: LaunchNavigator,
                private geoCoder: NativeGeocoder,
    ) {
    }

    serviceRegions: any = []
    serviceLocation: boolean = false;
    chooseLocation: boolean = true;
    backView: boolean = false;
    loader: boolean = true;
    locateCheck: boolean = false;

    ionViewWillEnter() {
        if (localStorage.getItem("location") || localStorage.getItem("place")) {
            this.location.pop = false;
            this.router.navigate(['/bookservice']);
        } else {
            this.location.pop = false;
            this.loader = false;
        }

    }

//  getServiceLocations(){
//   var post={
//     "id":790
//   }
//   this.service.locationSearch(post).subscribe((res:any)=>{
//     this.serviceRegions=res;
//     this.loader = false;
//   },
//   err=>{
//     this.handler.err(err);
//    this.loader = false;
//   })
// }


    askToTurnOnGPS() {
        this.locateCheck = true;
        this.LocationAccuracy.request(this.LocationAccuracy.REQUEST_PRIORITY_HIGH_ACCURACY).then(
            () => {
                this.setLoc()
            },
            error => {
                alert('Device location access is required to fetch your current location');
                this.locateCheck = false;
            }
        );
    }


    setLoc() {
        if (this.platform.ANDROID || this.platform.IOS) {
            console.log("DENY", this.handler.deny);
            this.locateCheck = true;
            this.loader = true;
            let options: NativeGeocoderOptions = {useLocale: true, maxResults: 1};
            this.loc.getCurrentPosition().then(res => {
                    this.geoCoder.reverseGeocode(res.coords.latitude, res.coords.longitude, options).then((result: NativeGeocoderResult[]) => {
                            this.loader = false;
                            this.handler.deny = 0;
                            localStorage.removeItem('deny');
                            let x: any = result;
                            localStorage.removeItem("place");
                            localStorage.setItem('location', JSON.stringify(x));
                            let loc;
                            loc = JSON.parse(localStorage.getItem('location'));
                            this.location.lat = loc[0].latitude;
                            this.location.lon = loc[0].longitude;
                            this.location.zipcode = loc[0].postalCode;
                            this.location.street = loc[0].thoroughfare;
                            this.location.stateId = loc[0].administrativeArea;
                            if (loc[0].locality) {
                                this.location.cityId = loc[0].locality;
                            } else {
                                this.location.cityId = loc[0].subAdministrativeArea;
                            }
                            if (loc[0].subLocality) {
                                this.location.regionId = loc[0].subLocality;
                            } else {
                                this.location.regionId = loc[0].neighborhood;
                            }
                            this.getLocationDetails(this.location.regionId);
                            this.router.navigate(['/bookservice'])
                            this.locateCheck = false;
                        },
                        err => {
                            this.location.locationTrue = false;
                            this.loader = false;
                            this.locateCheck = false;
                            this.handler.err(err);
                        })
                },
                err => {
                    console.error(err);
                    this.handler.deny++;
                    console.log("DENY", this.handler.deny);
                    if (this.handler.deny > 2 && !localStorage.getItem('deny')) {
                        this.handler.staticError("Please turn on location access permission for App,from Settings");
                        localStorage.setItem("deny", "1");
                    }
                    if (localStorage.getItem('deny')) {
                        this.handler.staticError("Please turn on location access permission for App,from Settings");
                    }
                    this.loader = false;
                    this.locateCheck = false;
                    this.location.locationTrue = false;
                })
        } else {
            this.location.locationTrue = false;
            this.router.navigate(['/bookservice'])
        }
        this.location.serviceArea = true;

    }

    getLocationDetails(data) {
        var post = {
            "id": 790,
            "region": data
        }
        this.service.locationSearch(post).subscribe((res: any) => {
            if (res != null) {
                this.location.locationTrue = true;
                localStorage.setItem('locationTrue', 'true');
            } else {
                this.location.locationTrue = false;
                localStorage.setItem('locationTrue', 'false');
                this.handler.err('Selected service is not provided in this region!!! Please select different region');
            }
        }, err => {
            this.location.locationTrue = false;
            localStorage.setItem('locationTrue', 'false');
            this.handler.err(err);
        })

    }

    openLocation() {
        this.location.lat = "";
        this.location.lon = "";
        this.location.zipcode = "";
        this.location.street = "";
        this.location.stateId = "";
        this.location.cityId = "";
        this.location.regionId = "";
        this.askToTurnOnGPS();

    }

    onInput() {
        this.location.serviceArea = true;
        this.location.autoComplete();
    }

    manualSetLoc() {
        this.location.pop = true;
        this.backView = true;
    }

    openPop() {
        this.location.pop = true;
        this.backView = false;
    }

    popClose() {
        this.location.pop = false;
        this.location.newSearch = "";
        this.location.dummy = false;
        this.loader = false;
    }

    popClose1() {
        this.location.pop = false;
        this.location.newSearch = "";
        this.location.dummy = false;
        this.loader = false;
    }

// ngDoCheck(): void {
//   if(this.location.booking ){
//     this.location.booking = false;
//     this.router.navigate(['/bookservice']) 
//   }
// }

}
